import { primaryThemeColors } from "./primaryThemeColors";
import { primaryThemeFonts } from "./primaryThemeFonts";

const primary = {
  colors: primaryThemeColors,
  font: primaryThemeFonts,
};

export default primary;
